var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.primaryName())+" "+_vm._s(_vm.secondaryName()))]),_c('p',[_vm._v(_vm._s(_vm.address())+" "+_vm._s(_vm.mobile()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }